import { type Plan } from '@/utils/mapProductObject';

export const filterOutWeeklyPlans = (plans: Plan[]): Plan[] => {
  const nonWeeklyPlans = plans.filter((plan) => !plan.sku.includes('weekly'));

  // edge case: if every plan received happens to be weekly, keep showing the unfiltered list
  return nonWeeklyPlans.length > 0 ? nonWeeklyPlans : plans;
};
